<template>
  <div class="content-center">
    <div class="banner">
      <div class="title">供应链金融服务</div>
      <div class="sub-title">聚焦产业互联网,服务下沉市场中小微企业，降低产业链融资成本，普惠金融方面助力商家经营快速发展</div>
      <div
        class="btn"
        @click="openModal"
      >业务咨询</div>
    </div>
    <div class="apply">
      <div class="sk-block-title">
        <div class="title">产业应用</div>
      </div>
      <div class="content">
        <div class="wrap">
          <div class="item">
            <img src="@/assets/images/industry/finance_apply1.png" alt="">
            <span>家用电器</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply2.png" alt="">
            <span>数码3c</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply3.png" alt="">
            <span>酒水饮料</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply4.png" alt="">
            <span>农资行业</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply5.png" alt="">
            <span>交通出行</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply6.png" alt="">
            <span>家居建材</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply7.png" alt="">
            <span>餐饮行业</span>
          </div>
          <div class="item">
            <img src="@/assets/images/industry/finance_apply8.png" alt="">
            <span>快消行业</span>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="sk-block-title">
        <div class="title">产品优势</div>
      </div>
      <diV class="content">
        <div class="item">
          <img src="@/assets/images/industry/finance_advantage1.png" alt="">
          <div class="title">产品多元</div>
          <p>
            基于客户需求和银行风险定位，提供订单、应收账款、融资租赁等多元化的供应链融资产品，帮助中小企业匹配到最合适的金融产品。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/industry/finance_advantage1.png" alt="">
          <div class="title">融资便捷</div>
          <p>
            整合银行及第三方支付账户体系，基于真实贸易背景帮助企业打通产业链交易全流程，提高授信成功率，提升企业融资效率。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/industry/finance_advantage1.png" alt="">
          <div class="title">流程简化</div>
          <p>
            搭建互联网交易平台，支持企业在线进行融资申请、签约、收款等操作，提供远程账户开立服务，进一步降低企业操作门槛。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/industry/finance_advantage1.png" alt="">
          <div class="title">风控安全</div>
          <p>
            构建场景式金融风控模型，从企业资格、融资额度、材料审核、项目审批等多个环节进行科学管理，规范供应链生态健康发展，保障资金安全。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/industry/finance_advantage1.png" alt="">
          <div class="title">产业协同</div>
          <p>
            大数据实时监测预警企业信用变化、供应链异动，实现产业端数据传递闭环，多核心企业资源共享，实现产业协同，多场景融合。
          </p>
        </div>
      </div>
    </div>
    <div class="cooperate">
      <div class="sk-block-title">
        <div class="title">合作机构</div>
      </div>
      <div class="content">
        <!-- <div class="prev" /> -->
        <div class="imgWrap">
          <img src="@/assets/images/industry/finance_cooperate1.png" alt="">
          <img src="@/assets/images/industry/finance_cooperate2.png" alt="">
          <img src="@/assets/images/industry/finance_cooperate3.png" alt="">
          <img src="@/assets/images/industry/finance_cooperate4.png" alt="">
          <img src="@/assets/images/industry/finance_cooperate5.png" alt="">
        </div>
        <!-- <div class="next" /> -->
      </div>
    </div>
    <CarouselItem title="金融服务" />
    <ConsultForm info-sources="金融服务" />
    <TryModal v-if="visible" :visible="visible" info-sources="金融服务" @cancel="modalClose" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Finance,
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
  .banner {
    padding: 95px 0 93px;
    background: url("~@/assets/images/industry/finance_bannerBg.png") no-repeat center;
    .title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .sub-title {
      font-size: 20px;
      color: #FFFFFF;
      margin-top: 31px;
    }
    .btn {
      width: 200px;
      height: 58px;
      line-height: 58px;
      background: #3986FF;
      color: #fff;
      border-radius: 6px;
      font-size: 22px;
      margin: 69px auto 0;
    }
  }
  .apply {
    padding-bottom: 60px;
    .content {
      width: 1202px;
      margin: 19px auto 0;
      .wrap {
        margin-right: -206px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .item {
        display: flex;
        flex-direction: column;
        margin-top: 40px;
        margin-right: 206px;
        span {
          font-size: 20px;
          font-weight: 500;
          color: #595961;
          line-height: 28px;
          padding-top: 14px;
        }
      }
    }
  }
  .advantage {
    background: #fafafa;
    padding-bottom: 60px;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 50px auto 0;
      .item {
        width: 224px;
        height: 394px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        border-radius: 6px;
        padding: 54px 34px 38px;
        .title {
          font-size: 24px;
          font-weight: 500;
          color: #595961;
          line-height: 33px;
          margin: 16px 0 22px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: #595961;
          line-height: 30px;
        }
      }
    }
  }
  .cooperate {
    padding-bottom: 50px;
    .content {
      display: flex;
      align-items: center;
      width: 1220px;
      margin: 50px auto 0;
      .prev, .next {
        width: 40px;
        height: 40px;
        background: #F2F7FF;
        border-radius: 50%;
      }
    }
  }
</style>
